import { checkoutShippingAddressesStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingAddresses";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

checkoutShippingAddressesStyles.addressContainer = {
    css: css`
        ${GridOffset} {
            width: 100% !important;
            margin: -15px -10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin: 0px;
                            ${GridOffset} {
                                width: 100%;
                                max-width: 100%;
                                margin: 0px;
                                ${GridItemStyle} {
                                    padding: 0px;
                                }
                            }
                        `,
                        css`
                            margin: 0px;
                            ${GridOffset} {
                                width: 100%;
                                max-width: 100%;
                                margin: 0px;
                                ${GridItemStyle} {
                                    padding: 0px;
                                }
                            }
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        }
    `,
};

checkoutShippingAddressesStyles.billingAddressGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding: 0px;
                    `,
                    css`
                        padding: 0px;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )};
    `,
};

checkoutShippingAddressesStyles.shippingAddressGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding: 0px;
                    `,
                    css`
                        padding: 0px;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )};
    `,
};
